import { createSelector } from 'reselect';

const selectData = state => state.screens.Dashboard.newProjectsWithOrderReport.data;

export default createSelector(
  selectData,
  (data) => data
)
